/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {StateService} from '@uirouter/core';
import {ADMIN_LIST_IMPORTS} from './admin-list-imports';

@Component({
  standalone: true,
  imports: ADMIN_LIST_IMPORTS,
  selector: 'adn-list-default-actions',
  template: `
    @if (!readOnly) {
      <a name="adnListNew"
         class="btn btn-default btn-xs"
         [attr.href]="newHref"
         (click)="goToNew($event)">
        <span class="fa fa-fw fa-plus-circle"></span>
        <span>{{ 'button.add.new' | ogTranslate }}</span>
      </a>
    }
  `
})
export class ListDefaultActionsComponent {
  @Input() readOnly: boolean;
  /** Optional override when list state is not the current state. */
  @Input() newStateName: string;

  constructor(private readonly stateService: StateService) {
  }

  get newHref(): string {
    return this.stateService.href(this.resolveNewStateName(), null, {inherit: false}) || '';
  }

  goToNew(event: Event): void {
    event.preventDefault();
    this.stateService.go(this.resolveNewStateName());
  }

  private resolveNewStateName(): string {
    if (this.newStateName) {
      return this.newStateName;
    }
    // Hard-code from current list state — relative uiSref like ".new" has no
    // reference point in context components.
    return this.stateService.current.name + '.new';
  }

}
